<template>
  <a-locale-provider :locale="zh_CN">
    <a-modal
      centered
      title="合并档案"
      v-model="visible"
      width="60%"
      okText="确认"
      @cancel="onCancel"
      @ok="submitData"
      :maskClosable="false"
      :destroyOnClose="true"
      :confirmLoading="confirmLoading"
      :getContainer="getContainer"
    >
      <a-spin :spinning="spinning" id="mergeBox">
        <data-table class="merge-table" ref="mergeTable" :option="option">
          <template slot="headAction">
            <a-button type="danger" @click="autoMerge">自动筛选</a-button>
          </template>
        </data-table>
      </a-spin>
    </a-modal>
  </a-locale-provider>
</template>
<script>
import { cache } from "@/utils/common.js";
import { DataTable } from "@/components/dataTable";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "MergeGuestHistory",
  components: {
    DataTable
  },
  data() {
    return {
      zh_CN,
      confirmLoading: false,
      spinning: false,
      visible: false,
      user: null,
      params: {},
      gridData: []
    };
  },
  created() {
    this.user = cache.get("user");
    this.option = {
      //搜索框内容
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "Keyword",
            props: {
              placeholder: "姓名、电话、身份证号"
            }
          }
        ],
        onSubmitBefore: values => {
          if (values.Keyword == "") {
            this.$message.error("请先输入关键字搜索");
            return false;
          }
          return values;
        }
      },
      //表格内容
      grid: {
        api: "Guest_List", //数据表格api
        autoLoad: false,
        rowSelect: true,
        PageSize: 10000,
        pagination: false,
        props: {
          scroll: {
            y: 450
          }
        },
        params: this.params,
        columns: [
          {
            title: "姓名",
            dataIndex: "Name",
            width: "20%"
          },
          {
            title: "电话",
            width: "20%",
            dataIndex: "Phone"
          },
          {
            title: "性别",
            dataIndex: "Sex",
            width: "15%"
          },
          {
            title: "身份证号",
            dataIndex: "IdNumber"
          }
        ],
        loadData: res => {
          this.gridData = res.Data.Datas;
        }
      }
    };
  },
  mounted() {},
  methods: {
    getContainer() {
      return document.querySelector("#app");
    },
    show() {
      this.visible = true;
    },
    onCancel() {
      this.visible = false;
    },
    autoMerge() {
      const json = this.$refs.mergeTable.getRef("headSearchForm").getData();
      this.params = {
        ...this.params,
        ...json,
        Repeat: "R"
      };
      this.$refs.mergeTable.onSearchSubmit({
        ...this.params
      });
    },
    submitData() {
      let rows = this.$refs.mergeTable.getSelecteds();
      if (rows.length < 2) {
        this.$message.error("请选择至少两条合并数据");
        return false;
      }
      let baseData = rows[0];
      const data = cloneDeep(rows);
      data.splice(0, 1);
      let ids = [];
      data.forEach(el => {
        ids.push(el.Id);
        baseData.Name = baseData.Name ? baseData.Name : el.Name;
        baseData.Phone = baseData.Phone ? baseData.Phone : el.Phone;
        baseData.Sex = baseData.Sex ? baseData.Sex : el.Sex;
        baseData.IdNumber = baseData.IdNumber ? baseData.IdNumber : el.IdNumber;
      });
      // this.visible = false;
      this.$emit("update", baseData, ids);
    }
  }
};
</script>

<style lang="less" scoped>
.data-table {
  min-height: 500px;
}
</style>
